import { useEffect, useState } from 'react';

/**
 * Returns the value only after it has stopped changing for `delayMs` — used to
 * avoid firing an API request on every keystroke of a search input.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handle = setTimeout(() => {
            setDebouncedValue(value);
        }, delayMs);
        return () => clearTimeout(handle);
    }, [value, delayMs]);

    return debouncedValue;
}
